/**
 * 问卷设置
 * Ariel 2020/4/7
 */
import React from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';
import { utils_tool, framework_tool } from '@/tool';
import SurveyAuthSelect from "./surveyAuthSelect";

let { Session } = utils_tool;
let { WizContainer } = framework_tool

class SurveyAuth extends WizContainer {
  componentName = 'surveyAuth';

  constructor(props) {
    super(props);
    this.state = {
      id: props.surveyId,
      questionIds: props.initInfo && props.initInfo['questionIds'] ? props.initInfo : [],
      initialValue: {},
      resetTime: new Date().getTime()
    }
  }

  _componentDidMount() {
    this.doActions([
      {
        path: 'survey/authInfo',
        payload: {
          key: 'authInfoKey',
          apiParams: { id: this.state.id }
        }
      },
      {
        path: 'survey/getSurveyInfo',
        payload: {
          key: 'getSurveyInfo',
          apiParams: { id: this.state.id }
        }
      }
    ]);
    const arr = [];
    this.setState({
      data: arr
    });
  }

  _fitterValues() {
    return this._survey && this._survey._fitterValues()
  }

  propsAndStateOnChange = {
    surveyInfo: this._surveyInfo.bind(this),
    authInfo: this._authInfo.bind(this),
    saveAuthKey: this._saveAuthKey.bind(this),
  };

  _surveyInfo(nextProps, nextState) {
    let { surveyInfo } = nextProps
    if (surveyInfo && surveyInfo['success']) {
      nextState.questionIds = surveyInfo['data'].questionIds
    } else {
      wizNotice.error(surveyInfo && surveyInfo['msg'] || '获取问卷信息失败，请稍后尝试')
    }
    return false
  }

  _authInfo(nextProps, nextState) {
    let { authInfo } = nextProps
    if (authInfo && authInfo['success']) {
      nextState.initialValue = authInfo['data']
    } else {
      wizNotice.error(authInfo && authInfo['msg'] || '操作失败,请稍后尝试')
    }
    return false
  }

  _saveAuthKey(nextProps, nextState) {
    let { saveAuthKey,replaceClose } = nextProps
    if (saveAuthKey && saveAuthKey['success']) {
      wizNotice.success(saveAuthKey['msg'])
      replaceClose?replaceClose():this.jumpPage('replace', '/biz/survey');
      return true
    } else {
      wizNotice.error(saveAuthKey && saveAuthKey['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _render() {
    const { initialValue, questionIds } = this.state
    const { surveyLoading, prevFunc } = this.props
    const selectProps = {
      loading: surveyLoading,
      prevFunc: prevFunc,
      this: this,
      id: this.state.id,
      initialValue: initialValue,
      submit: (value, flag) => {
        if (flag) {
          if (questionIds && questionIds.length) {
            this.doAction({
              path: 'survey/enable',
              payload: {
                key: "surveyEnable",
                apiParams: { id: this.state.id, status: 1 }
              }
            })
          } else {
            wizNotice.error('该问卷还未设计题目，不能发布')
            return false;
          }
        }
        let saveRequest = {}
        // if (value['dataAuth']) {
        //   saveRequest['orgIds'] = dataAuth['orgIds'] && dataAuth['orgIds'].map(p => (p.id))
        //   saveRequest['positionIds'] = dataAuth['positionIds'] && dataAuth['positionIds'].map(p => (p.id))
        //   saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'] && dataAuth['positionCategoryIds'].map(p => (p.id))
        //   saveRequest['personIds'] = dataAuth['personIds'] && dataAuth['personIds'].map(p => (p['id']))
        // }

        if (value['dataAuth']) {
          let dataAuth = value['dataAuth']
          if (dataAuth && dataAuth.isAll) {
            saveRequest.isAll = dataAuth.isAll
          }
          if (dataAuth["groupId"] && dataAuth["groupId"].length) {
            saveRequest["groupId"] = dataAuth["groupId"].map((p) => p["id"]).toString();
          } else if (dataAuth["groupId"] && dataAuth["groupId"]["id"]) {
            saveRequest["groupId"] = dataAuth["groupId"]["id"].toString();
          }else{
            saveRequest['orgIds'] = dataAuth['orgIds'] && dataAuth['orgIds'].map(p => (p.id))
            saveRequest['positionIds'] = dataAuth['positionIds'] && dataAuth['positionIds'].map(p => (p.id))
            saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'] && dataAuth['positionCategoryIds'].map(p => (p.id))
            saveRequest['personIds'] = dataAuth['personIds'] && dataAuth['personIds'].map(p => (p['id']))
          }
        }
        saveRequest['id'] = this.state.id
        this.doAction({
          path: 'survey/saveAuth',
          payload: {
            key: "surveySaveAuthKey",
            apiParams: { ...saveRequest }
          }
        })
      },
    };
    return <SurveyAuthSelect {...selectProps} />
  }

}

const mapStateToProps = (state, ownProps) => {

  const { survey } = state;
  const surveyInfo = modelUtils.getModelEntity(survey, "getSurveyInfo");
  const authInfo = modelUtils.getModelEntity(survey, "authInfoKey");
  const saveAuthKey = modelUtils.getModelEntity(survey, "surveySaveAuthKey");
  const load = modelUtils.getLoadingState(state, 'survey');

  return {
    surveyInfo,
    authInfo,
    saveAuthKey,
    ...load
  }
};

export default connect(mapStateToProps)(SurveyAuth)
